angular.module("modalViewDocuments.components",["app.services"])
.component("modalViewDocuments",{
    templateUrl:"ng/components/modalViewDocuments/modalViewDocument.view.html",
    bindings:{},
    controllerAs: "modalViewDocumentsCtrl",
    controller: modalViewDocumentsController
});

function modalViewDocumentsController(
    FileUploader,
    $modalService,
    $rootScope,
    $transactionFactory,
    $financialApiService,
    $configService,
    $portalService,
    $download
){

    var self = this;

    self.$onInit= function(){
      self.restrictedFiles={
        selected: false
      }
      self.showRestrictedFiles= $configService.getAppConfig().allFunctionalities.includes("DOC_RISERVATI")
      self.$portalService= $portalService;
      self.isOpen = false;
      self.financialModel = $transactionFactory.get();
      $transactionFactory.clear();
      getPrintedDocs(self.financialModel);
      getUploadedDocs(self.financialModel)
      self.genericDoc = [];

    }

    self.closeModal = function(){

        $modalService.closeModal("viewDocuments");
        $rootScope.openModalViewDocs= false;
    }

    var getPrintedDocs = function(financialModel){
        self.waitForRestGetPrintedDocs= true;
        $financialApiService.getPrintedDocs(financialModel)
        .then(function(response){
            self.printedDocsList = response.documents;
            self.waitForRestGetPrintedDocs= false;
        })
        .catch(function(error){
            console.log(error);
            self.waitForRestGetPrintedDocs= false;
        })

    }

    var getUploadedDocs = function(financialModel){
        self.waitForRestGetUploadedDocs= true;
        $financialApiService.getUploadedDocs(financialModel)
        .then(function(response){
            self.variDocListUploaded = response.documents;
            self.receivedDocsList = self.variDocListUploaded.filter( function(doc) {return doc.cdDoc !== "GENP" && doc.cdDoc !== "GENC"});
            self.setGenericDocs(self.variDocListUploaded);
            self.waitForRestGetUploadedDocs= false;
        })
        .catch(function(error){
            console.log(error);
            self.waitForRestGetUploadedDocs= false;
        })

    }

    self.setGenericDocs = function (receivedDocs) {
      self.genericDoc = [];
      self.isPreventivoDocs = receivedDocs.find( function(doc) {return doc.cdDoc === 'GENP'});
            self.preventivoDoc = [];
            if (self.isPreventivoDocs) {
              self.preventivoDoc = receivedDocs.find( function(doc) {return doc.cdDoc === 'GENP'}).uploadedFiles;
              self.genericDoc = self.genericDoc.concat(self.preventivoDoc);
            }
            self.isContrattoDocs = receivedDocs.find( function(doc) {return doc.cdDoc === 'GENC'});
            self.contrattoDoc = [];
            if (self.isContrattoDocs) {
              self.contrattoDoc = receivedDocs.find( function(doc) {return doc.cdDoc === 'GENC'}).uploadedFiles;
              self.genericDoc = self.genericDoc.concat(self.contrattoDoc);
            }
    }

    self.generdownloadDoc = function (file) {
      var input={
        downloadKey: file.downloadKey
      }
      var url="/uni/downloadDocDigital/service-infos/"
      $download.getGenericDownload(url, input)
      .then(function(response){
        console.log(response)
      })
    };

    self.openCloseUpload = function(){
        $(".dragandrophandler").slideToggle(1500);
        self.isOpen = !self.isOpen;
    }

      /* inizio */
  var obj = jQuery("#dragandrophandler");
  obj.on("dragenter", function (e) {
    e.stopPropagation();
    e.preventDefault();
    jQuery(this).css("border", "2px solid #0B85A1");
  });
  obj.on("dragover", function (e) {
    e.stopPropagation();
    e.preventDefault();
  });
  obj.on("drop", function (e) {
    jQuery(this).css("border", "2px dotted #0B85A1");
    e.preventDefault();
    var files = e.originalEvent.dataTransfer.files;

    //We need to send dropped files to Server
    handleFileUpload(files, obj);
    files=[];
  });

  var handleFileUpload = function (files) {
    self.disabledForUploadingInProgress = true;
    self.enableLoader=true;
    var formData = new FormData();
    files = Object.keys(files).map(function (key) {
      return files[key]; 
    });
    files.forEach(function (e) {
      formData = new FormData();
      appendToForm(formData, "file", e);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "filename", e.name);
      appendToForm(formData, "idPratica", self.financialModel.leasingData.id);
      appendToForm(formData, "numeroAnno", self.financialModel.leasingData.preventivo.anno);
      appendToForm(formData, "numeroPreventivo", self.financialModel.leasingData.preventivo.numero);
      appendToForm(formData, "restricted", self.restrictedFiles.selected);
        $financialApiService
          .splitPdf(formData)
            .then(function(response){

                response.forEach(function(element){

                    var index = self.variDocListUploaded
                        .findIndex(function(e){
                          return e.cdDoc == element.cdDoc
                        })

                    if(index <0){
                      self.variDocListUploaded.push(element)
                    }else{

                    self.variDocListUploaded.forEach(function(singleElement){
                      if(singleElement.cdDocNsil == element.cdDocNsil){
                        singleElement.uploadedFiles = singleElement.uploadedFiles.concat(element.uploadedFiles);
                      }else{
                        console.log("non è presente");
                      }
                    })
                    }
                })
                self.receivedDocsList = self.variDocListUploaded.filter( function(doc) {return doc.cdDoc !== "GENP" && doc.cdDoc !== "GENC"});
                self.setGenericDocs(self.variDocListUploaded);
                self.enableLoader=false;
            })
            .catch(function(error){
              console.log(error);  
              self.disabledForUploadingInProgress = false;
              self.enableLoader=false;
            });
    }); 
  };
  /* fine */
  /* inizio uploader file */
    self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.isSplit = arguments[4] && arguments[4];
  };

self.finalUpload = function () {
    self.enableLoader=true;
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    if (!self.isSplit) {
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos/" +
      encodeURIComponent(self.model.leasingData.preventivo.anno) +
      "/" +
      encodeURIComponent(self.model.leasingData.preventivo.numero) +
      "/FINANCIAL-" +
      self.singleFile.codiceDocNSIL;
    }
    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    var filesUpload = document.querySelector(
      "#uploadInput_document_" + self.currentCodeTypeNameIndex
    ).files;
    filesUpload= Object.keys(filesUpload).map(function(key){return filesUpload[key]});
    var formData = new FormData();

   // var reader = new FileReader();
   // reader.onload = function (event) {
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
      var ndgCliente = self.financialModel.financialCustomer.metadata.riUserG.ndg;
        filesUpload.forEach(function(file){
        formData = new FormData();
        appendToForm(formData, "file", file);
        appendToForm(formData, "FINANCIAL", "FINANCIAL");
        appendToForm(formData, "ndgCliente", ndgCliente);
        appendToForm(formData, "filename", file.name);
        appendToForm(formData, "idPratica", self.financialModel.leasingData.id);
        appendToForm(formData, "numeroAnno", self.financialModel.leasingData.preventivo.anno);
        appendToForm(formData, "numeroContratto", self.financialModel.leasingData.contratto.numero);
        appendToForm(formData, "modulo", self.financialModel.leasingData.contratto.modulo);
        appendToForm(formData, "numeroPreventivo", self.financialModel.leasingData.preventivo.numero);
        appendToForm(formData, "restricted", self.restrictedFiles.selected);
 
        $financialApiService
          .splitPdf(formData)
            .then(function(response){
                response.forEach(function(element){

                    var index = self.variDocListUploaded
                        .findIndex(function(e){
                          return e.cdDoc == element.cdDoc
                        })

                    if(index <0){
                      self.variDocListUploaded.push(element)
                    }else{

                    self.variDocListUploaded.forEach(function(singleElement){
                      if(singleElement.cdDocNsil == element.cdDocNsil){
                        singleElement.uploadedFiles = singleElement.uploadedFiles.concat(element.uploadedFiles);
                      }else{
                        console.log("non è presente");
                      }
                    })
                    }
                })
                self.receivedDocsList = self.variDocListUploaded.filter( function(doc) {return doc.cdDoc !== "GENP" && doc.cdDoc !== "GENC"});
                self.setGenericDocs(self.variDocListUploaded);
                self.enableLoader=false;        
            })
            .catch(function(error){
              console.log(error);  
              self.disabledForUploadingInProgress = false;
              self.enableLoader=false;
            });

      });


  }; 


  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    }
    var fileName = fileItem.file.name;
/*     if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".zipx") > -1 ||
      fileName.toLowerCase().indexOf(".rar") > -1
    ) { */
    self.uploader.queue[0].progress = 100;



    /* } else {
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    } */
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
    self.uploadInProgess({
      uploadInProgess: true,
    });
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) {};

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {

  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    self.uploadInProgess({
      uploadInProgess: false,
    });

    fileItem.remove();
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
      self.checkStatusOfFile();
      checkIfFileRequestIsUploaded();
    }
    self.uploader.queue = [];

    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  /* fine uploader file */

/*   SEZIONE NON RICHIESTA MA IMPLEMENTATA PER EVENTUALI USI FUTURI
  self.checkPrintedDoc = function (el) {
    el.selected = !el.selected;

    checkPrintedDocElementSelected();
  }; */

  self.checkReceivedDocs= function (el) {
    el.selected = !el.selected;

    checkReceivedDocElementSelected();
  };

  self.checkGenericDocs= function (el) {
    el.selected = !el.selected;

    checkGenericDocElementSelected();
  };

/* SEZIONE NON RICHIESTA MA IMPLEMENTATA PER EVENTUALI USI FUTURI
  var checkPrintedDocElementSelected = function(){
    self.printedDocsElementSelected = false;

    self.printedDocsList.forEach(function(element){
      self.printedDocsElementSelected = self.printedDocsElementSelected || element.uploadedFiles.some(function(elem){
        return elem.selected == true;
      })
    })

  } */


  var checkReceivedDocElementSelected = function(){
    self.receivedDocsElementSelected = false;

    self.receivedDocsList.forEach(function(element){
      self.receivedDocsElementSelected = self.receivedDocsElementSelected || element.uploadedFiles.some(function(elem){
        return elem.selected == true;
      })
    })

  }


  var checkGenericDocElementSelected = function(){
    self.genericDocsElementSelected = false;


      self.genericDocsElementSelected = self.genericDoc.some(function(elem){
        return elem.selected == true;
      })

  }


  self.removeDocument = function(tipo){
    self.listOfDocumentDeleting=[];
    if(tipo== 'generici'){
      self.listOfDocumentDeleting= self.genericDoc
      .filter(function(element){
           return element.selected == true
           })
      .map(function(mapping){
           return mapping.id
          })
    }else if(tipo == 'ricevuti'){
      self.receivedDocsList.forEach(function(element){
        self.listOfDocumentDeleting= self.listOfDocumentDeleting.concat(element.uploadedFiles.
            filter(function(elem){
              return elem.selected == true;
            })
            .map(function(mapping){
                 return mapping.id
            })
        )
      })
    }
/*  QUESTA SEZIONE NON E' STATA RICHIESTA IMPLEMENTATA PER USI FUTURI
    else if(tipo === 'stampati'){
      self.printedDocsList.forEach(function(element){
        self.listOfDocumentDeleting= self.listOfDocumentDeleting.concat(element.uploadedFiles.
            filter(function(elem){
              return elem.selected == true;
            })
            .map(function(mapping){
                 return mapping.id
            })
          )
      })
    } */
    callRestDeletingFiles(tipo);
  }

  var callRestDeletingFiles= function(tipo){

    $financialApiService.deleteFileList(self.listOfDocumentDeleting)
    .then(function(response){
      if(response.success){
        eliminaFiles(tipo);
      }
    })
    .catch(function(error){
      console.log(error);
    })
  }

  var eliminaFiles = function(tipo){

    if(tipo== 'generici'){
      self.listOfDocumentDeleting.forEach(function(element){
        self.genericDoc = self.genericDoc
                          .filter(function(deleted){
                            return deleted.id != element
                          })
        self.variDocListUploaded.forEach(function(iesimo){
            if(iesimo.cdDoc == "GENC" || iesimo.cdDoc == "GENP"){
               iesimo.uploadedFiles = iesimo.uploadedFiles.filter(function(deleted){
                 return deleted.id != element
               })
            }
        })
      })
      checkGenericDocElementSelected();
    }else if(tipo == 'ricevuti'){
      self.listOfDocumentDeleting.forEach(function(element){
         self.receivedDocsList.forEach(function(internalElement){
           internalElement.uploadedFiles = internalElement.uploadedFiles
                                            .filter(function(deleted){
                                              return deleted.id != element
                                            }) 
         })
      })

      self.receivedDocsList = self.receivedDocsList.filter(function(notNull){
         return notNull.uploadedFiles.length > 0;
      })
      checkReceivedDocElementSelected();
    }

  }
}